import {
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance,
  toDuration7gy6v749ektt as toDuration,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import {
  DurationUnit_SECONDS_getInstance3jias9ne5z4er as DurationUnit_SECONDS_getInstance,
  DurationUnit_MILLISECONDS_getInstance15owevua4zjxe as DurationUnit_MILLISECONDS_getInstance,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { delay1diib1rb84y4j as delay } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  BaseResourceUse29ny90pfhtji3 as BaseResourceUse,
  waitFor2a46u14jq5a6t as waitFor,
  debounce38x13ynq48dvf as debounce,
} from './utils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { lens3m3nj3zkwtu6r as lens } from '../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import {
  plus18eogev54fmsa as plus,
  minus27abgkurcn6u0 as minus,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import { System_instance3dr57gee6r420 as System_instance } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  Never_getInstance32s86skpi7zck as Never_getInstance,
  Or3lq77uaxl3wr0 as Or,
} from '../../../../../lightning-server-shared/com/lightningkite/lightningdb/Condition.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { ReactiveState__getOrNull_impl_1asnfp2wx27g6rqhoxq as ReactiveState__getOrNull_impl_1asnfp } from '../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  distinct10qe1scfdvu5k as distinct,
  joinToString1cxrrlmo0chqs as joinToString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { simplifydei23qhed9ze as simplify } from '../../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionSimplify.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { use25wcggkyjf1ad as use } from '../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { reactive2pl1t9wy5gll5 as reactive } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function SharedCollectionUpdatesSocket$Req$wait$lambda(it) {
  return it;
}
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  // Inline function 'kotlin.time.Companion.seconds' call
  Companion_getInstance();
  var tmp$ret$0 = toDuration(4, DurationUnit_SECONDS_getInstance());
  var tmp = delay(tmp$ret$0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (equals($this.seo_1._v, $this.teo_1)) {
    var tmp0_safe_receiver = $this.ueo_1.zel_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      var tmp1_safe_receiver = $this.seo_1._v;
      tmp0_safe_receiver.hcv(['Update condition to ' + toString(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.uen_1) + ' failed.']);
    }
    $this.seo_1._v = null;
    _init_$updateCondition($this.ueo_1, $this.seo_1);
  }
  return Unit_instance;
}
var ReqClass;
function Req() {
  if (ReqClass === VOID) {
    class $ extends BaseResourceUse() {
      constructor($outer, condition, $box) {
        if ($box === VOID)
          $box = {};
        $box.sel_1 = $outer;
        super($box);
        this.pel_1 = condition;
        this.qel_1 = null;
        var tmp = this;
        tmp.rel_1 = lens(this.sel_1.bem_1, (it) => {
          var tmp0 = it.ven_1;
          var tmp$ret$0;
          $l$block_0: {
            // Inline function 'kotlin.collections.any' call
            var tmp;
            if (isInterface(tmp0, Collection())) {
              tmp = tmp0.i1();
            } else {
              tmp = false;
            }
            if (tmp) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
            var _iterator__ex2g4s = tmp0.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              if (element.pel_1.equals(this.pel_1)) {
                tmp$ret$0 = true;
                break $l$block_0;
              }
            }
            tmp$ret$0 = false;
          }
          return tmp$ret$0;
        });
      }
      oeo() {
        return this.pel_1;
      }
      neo() {
        return this.qel_1;
      }
      kal() {
        var _receiver__tnumb7 = this.sel_1.aem_1;
        _receiver__tnumb7.oam(plus(_receiver__tnumb7.f2(), this));
        this.qel_1 = System_instance.b1m();
      }
      lal() {
        var _receiver__tnumb7 = this.sel_1.aem_1;
        _receiver__tnumb7.oam(minus(_receiver__tnumb7.f2(), this));
        this.qel_1 = null;
      }
      tel($completion) {
        return waitFor(this.rel_1, SharedCollectionUpdatesSocket$Req$wait$lambda, $completion);
      }
    }
    initMetadataForClass($, 'Req', VOID, VOID, VOID, [0]);
    ReqClass = $;
  }
  return ReqClass;
}
var ListeningStatusClass;
function ListeningStatus() {
  if (ListeningStatusClass === VOID) {
    class $ {
      constructor($outer, fullCondition, requirements) {
        fullCondition = fullCondition === VOID ? Never_getInstance() : fullCondition;
        var tmp;
        if (requirements === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp = emptySet();
        } else {
          tmp = requirements;
        }
        requirements = tmp;
        this.wen_1 = $outer;
        this.uen_1 = fullCondition;
        this.ven_1 = requirements;
      }
    }
    initMetadataForClass($, 'ListeningStatus');
    ListeningStatusClass = $;
  }
  return ListeningStatusClass;
}
function _init_$updateCondition(this$0, lastSent) {
  if (!(ReactiveState__getOrNull_impl_1asnfp(this$0.xel_1.qdn().sah()) === true)) {
    var tmp0_safe_receiver = this$0.zel_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.hcv(["Can't update condition, socket is closed"]);
    }
    return Unit_instance;
  }
  if (!(lastSent._v == null)) {
    var tmp1_safe_receiver = this$0.zel_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.hcv(["Can't update condition, waiting on tentative send"]);
    }
    return Unit_instance;
  }
  // Inline function 'kotlin.run' call
  var r = this$0.aem_1.f2();
  if (r === this$0.bem_1.f2().ven_1) {
    var tmp0_safe_receiver_0 = this$0.zel_1;
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      tmp0_safe_receiver_0.hcv(['No need to update condition; already satisfied by exact requirements']);
    }
    return Unit_instance;
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(r, 10));
  var _iterator__ex2g4s = r.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$0 = item.pel_1;
    destination.v(tmp$ret$0);
  }
  var willSend = new (ListeningStatus())(this$0, simplify(Or().x3q(distinct(destination))), r);
  if (this$0.bem_1.f2().uen_1.equals(willSend.uen_1)) {
    this$0.bem_1.oam(willSend);
    var tmp2_safe_receiver = this$0.zel_1;
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.hcv(['No need to update condition; already satisfied by condition match']);
    }
    return Unit_instance;
  }
  lastSent._v = willSend;
  var tmp3_safe_receiver = this$0.zel_1;
  if (tmp3_safe_receiver == null)
    null;
  else {
    tmp3_safe_receiver.hcv(['Sending condition ' + toString_0(willSend.uen_1)]);
  }
  this$0.xel_1.sdn(willSend.uen_1);
  launch(this$0.wel_1, VOID, VOID, SharedCollectionUpdatesSocket$updateCondition$slambda_0(lastSent, willSend, this$0));
}
function SharedCollectionUpdatesSocket$desiredRequirements$lambda$lambda(it) {
  return toString_0(it.pel_1);
}
function SharedCollectionUpdatesSocket$listeningStatus$lambda$lambda(it) {
  return toString_0(it.pel_1);
}
var SharedCollectionUpdatesSocket$updateCondition$slambdaClass;
function SharedCollectionUpdatesSocket$updateCondition$slambda() {
  if (SharedCollectionUpdatesSocket$updateCondition$slambdaClass === VOID) {
    class $ {
      constructor($lastSent, $willSend, this$0) {
        this.seo_1 = $lastSent;
        this.teo_1 = $willSend;
        this.ueo_1 = this$0;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    SharedCollectionUpdatesSocket$updateCondition$slambdaClass = $;
  }
  return SharedCollectionUpdatesSocket$updateCondition$slambdaClass;
}
function SharedCollectionUpdatesSocket$updateCondition$slambda_0($lastSent, $willSend, this$0) {
  var i = new (SharedCollectionUpdatesSocket$updateCondition$slambda())($lastSent, $willSend, this$0);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var SharedCollectionUpdatesSocketClass;
function SharedCollectionUpdatesSocket() {
  if (SharedCollectionUpdatesSocketClass === VOID) {
    class $ {
      constructor(scope, socket, onChange, log) {
        log = log === VOID ? null : log;
        this.wel_1 = scope;
        this.xel_1 = socket;
        this.yel_1 = onChange;
        this.zel_1 = log;
        var tmp = this;
        // Inline function 'kotlin.collections.setOf' call
        var tmp$ret$0 = emptySet();
        // Inline function 'kotlin.also' call
        var this_0 = Signal().hak(tmp$ret$0);
        var it = this_0;
        it.vah(() => {
          var tmp0_safe_receiver = this.zel_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            var tmp = it.f2();
            tmp0_safe_receiver.hcv(['desiredRequirements is now ' + joinToString(tmp, VOID, VOID, VOID, VOID, VOID, SharedCollectionUpdatesSocket$desiredRequirements$lambda$lambda)]);
          }
          return Unit_instance;
        });
        tmp.aem_1 = this_0;
        var tmp_0 = this;
        // Inline function 'kotlin.also' call
        var this_1 = Signal().hak(new (ListeningStatus())(this));
        var it_0 = this_1;
        it_0.vah(() => {
          var tmp0_safe_receiver = this.zel_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            var tmp = toString_0(it_0.f2().uen_1);
            var tmp_0 = it_0.f2().ven_1;
            tmp0_safe_receiver.hcv(['listeningStatus is now ' + tmp + ' / ' + joinToString(tmp_0, VOID, VOID, VOID, VOID, VOID, SharedCollectionUpdatesSocket$listeningStatus$lambda$lambda)]);
          }
          return Unit_instance;
        });
        tmp_0.bem_1 = this_1;
        var lastSent = {_v: null};
        this.xel_1.tdl(() => {
          var tmp0_safe_receiver = this.zel_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.hcv(['Opened.']);
          }
          _init_$updateCondition(this, lastSent);
          return Unit_instance;
        });
        this.xel_1.tdn((it) => {
          var tmp0_safe_receiver = this.zel_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.hcv(['Message: ' + it.toString()]);
          }
          this.yel_1(it);
          var l = lastSent._v;
          var tmp;
          if (!(l == null) && equals(it.x3o_1, l.uen_1)) {
            lastSent._v = null;
            this.bem_1.oam(l);
            _init_$updateCondition(this, lastSent);
            tmp = Unit_instance;
          }
          return Unit_instance;
        });
        this.xel_1.udl((it) => {
          var tmp0_safe_receiver = this.zel_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.hcv(['Closed.']);
          }
          this.bem_1.oam(new (ListeningStatus())(this));
          return Unit_instance;
        });
        // Inline function 'kotlin.time.Companion.milliseconds' call
        Companion_getInstance();
        var tmp$ret$5 = toDuration(100, DurationUnit_MILLISECONDS_getInstance());
        var debouncedRequirements = debounce(this.aem_1, this.wel_1, tmp$ret$5);
        reactive(this.wel_1, ($this$reactive) => {
          var requirements = $this$reactive.daj(debouncedRequirements);
          var tmp;
          if (requirements.i1()) {
            this.bem_1.oam(new (ListeningStatus())(this));
            return Unit_instance;
          }
          use($this$reactive, this.xel_1);
          _init_$updateCondition(this, lastSent);
          return Unit_instance;
        });
      }
      cem(condition) {
        return new (Req())(this, condition);
      }
    }
    initMetadataForClass($, 'SharedCollectionUpdatesSocket');
    SharedCollectionUpdatesSocketClass = $;
  }
  return SharedCollectionUpdatesSocketClass;
}
//region block: exports
export {
  SharedCollectionUpdatesSocket as SharedCollectionUpdatesSocket32e1skqgvgdc7,
};
//endregion

//# sourceMappingURL=SharedCollectionUpdatesSocket.mjs.map
